
export default function SquareShape(baseX, baseY, corners) {
   
  const path =  `M ${baseX + corners[0].x},${baseY + corners[0].y} L ${baseX + corners[1].x},${baseY + corners[1].y} L ${baseX + corners[2].x},${baseY + corners[2].y} L ${baseX + corners[3].x},${baseY + corners[3].y} Z`;

  return path;
}


